import { createReducer, on } from '@ngrx/store';

import { loadPendingCountsSuccess } from './pendingCounts.actions';
import { IPendingCounts } from '@shared';

export interface pendingCountsState {
  pendingCounts: IPendingCounts;
}

export const initialState: pendingCountsState = {
  pendingCounts: {
    pendingInvoices: 0,
    pendingNirlatGiftOrders: 0,
    pendingPosts: 0,
    pendingBusinessSales: 0,
    pendingJobs: 0,
  },
};

const _pendingCountsReducer = createReducer(
  initialState,
  on(loadPendingCountsSuccess, (state, { pendingCounts }) => ({ ...state, pendingCounts })),
);

export function pendingCountsReducer(state: pendingCountsState | undefined, action: any) {
  return _pendingCountsReducer(state, action);
}
